import Axios from "axios";
import Cookies from 'js-cookie'
import qs from "qs"

let dns = null;
let dns_stream = null;
let isIptveditor = false;

// Inicializa os DNSs da config global
if (window.dns) setDns(window.dns);
if (window.dns_stream) dns_stream = window.dns_stream;

export function getImageUrl(url) {
    if (!url) return "/img/no_cover.jpg";
    if (url.startsWith("http://")) {
        return window.location.origin + "/proxy.php?url=" + encodeURIComponent(url);
    }
    return url;
}

export async function get(url) {
    return Axios.get(url);
}

export async function post(url, params = {}) {
    if (!dns && !url.startsWith('/')) return null;
    
    let fullUrl;
    if (url.startsWith('http')) {
        fullUrl = url;
    } else if (url.startsWith('/')) {
        const localUrl = window.location.origin + url;
        const queryString = qs.stringify(params);
        return Axios.get(localUrl + (localUrl.includes('?') ? '&' : '?') + queryString, { timeout: 25000 });
    } else {
        const cleanDns = dns.replace(/\/$/, '');
        const cleanUrl = url.replace(/^\//, '');
        fullUrl = cleanDns + '/' + cleanUrl;
    }
    
    const queryString = qs.stringify(params);
    if (queryString) {
        fullUrl += (fullUrl.includes('?') ? '&' : '?') + queryString;
    }
    
    const proxiedUrl = window.location.origin + "/proxy.php?url=" + encodeURIComponent(fullUrl);
    return Axios.get(proxiedUrl, { timeout: 25000 });
}

export function setDns(data) {
    if (!data) return;
    let finalDns = data;
    if (finalDns.endsWith("/")) finalDns = finalDns.slice(0, -1);
    dns = finalDns;
    Cookies.set("dns", finalDns, { expires: 365 })
}

export function getDns() { return dns; }
export function getDnsStream() { return dns_stream || dns; }
export function getIsIptveditor() { return isIptveditor; }
